import { render, staticRenderFns } from "./currency-float.vue?vue&type=template&id=23520a68&scoped=true&"
import script from "./currency-float.vue?vue&type=script&lang=js&"
export * from "./currency-float.vue?vue&type=script&lang=js&"
import style0 from "./currency-float.vue?vue&type=style&index=0&id=23520a68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23520a68",
  null
  
)

export default component.exports